import { Inertia } from "@inertiajs/inertia";
import { format } from "date-fns";

export const clientSideCart = true;

export const removeCartProduct = (productId, action = null, quantity = null, callback = null, recipientIndex = null, variant_key = null) => {
	const values = {
		product_id: productId,
		quantity: quantity,
		action: action,
		variant_key: variant_key,
	};

	const url = recipientIndex !== null && [0, 1, 2].includes(recipientIndex) ? route("frontend.cart.updateMultiCart") : route("frontend.cart.updateCart");

	Inertia.post(
		url,
		{ ...values, recipientIndex },
		{
			preserveScroll: true,
			onFinish: () => {
				callback && callback();
			},
		}
	);
};

export const formatDateTime = (dateTime = "", dateFormat = "dd/MM/yyyy, p") => {
	if (dateTime) {
		let date = format(new Date(dateTime), dateFormat);
		return date;
	} else {
		return "";
	}
};

export const findValue = (val = null, options = []) => {
	let obj = null;
	if (val && (val.constructor.name == "String" || val.constructor.name == "Number")) {
		options.map((i, k) => {
			if (i.value == val) {
				obj = i;
			}
		});
	} else if (val && val.constructor.name == "Array") {
		obj = [];
		val.map((j) => {
			obj.push(findValue(j, options));
		});
	}

	return obj;
};

export const dataURLtoFile = (dataurl, filename) => {
	let arr = dataurl.split(","),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new File([u8arr], filename, { type: mime });
};

// GA & PIXEL
export const makeGAEvent = (action, params = { event_category, event_label, value }) => {
	if (process.env.NODE_ENV == "development") {
		console.log("%cTHIS WILL BE SENT TO GOOGLE ANALYTICS:", "background: #000; color: #bada55");
		// console.log(`%cwindow.gtag("event", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2).replace(/"([^"]+)":/g, "$1:")});`, "color: #bada55");
		console.log(`%cwindow.gtag("event", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2)});`, "color: #bada55");
	} else {
		if (window && window.gtag && typeof window.gtag === "function") {
			// console.log("%cTHIS WILL BE SENT TO GOOGLE ANALYTICS:", "background: #000; color: #bada55");
			// console.log(`%cwindow.gtag("event", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2)});`, "color: #bada55");
			window.gtag("event", action, params);
		}
	}
};

export const makeFBQEvent = (action, params = {}) => {
	if (process.env.NODE_ENV == "development") {
		console.log("%cTHIS WILL BE SENT TO FACEBOOK ANALYTICS:", "background: #000; color: #bada55");
		// console.log(`%cwindow.fbq("track", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2).replace(/"([^"]+)":/g, "$1:")});`, "color: #bada55");
		console.log(`%cwindow.fbq("track", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2)});`, "color: #bada55");
	} else {
		if (window && window.fbq && typeof window.fbq === "function") {
			// console.log("%cTHIS WILL BE SENT TO FACEBOOK ANALYTICS:", "background: #000; color: #bada55");
			// console.log(`%cwindow.fbq("track", ${JSON.stringify(action, null, 2)}, ${JSON.stringify(params, null, 2)});`, "color: #bada55");
			window.fbq("track", action, params);
		}
	}
};

export const triggerEcommerceEvent = (trackType, data = {}) => {
	// console.log(trackType, data);
	switch (trackType) {
		case "VIEW_ITEM_LIST": // DONE
			// GA
			makeGAEvent("view_item_list", data);
			// Pixel: No relevant Pixel tag found
			break;
		case "VIEW_ITEM": // DONE
			// GA
			makeGAEvent("view_item", data);
			// Pixel
			makeFBQEvent("ViewContent", {
				content_ids: [data.items[0].id],
				content_category: data.items[0].category,
				content_name: data.items[0].name,
				content_type: "product",
				contents: [{ id: data.items[0].id, quantity: 1 }],
				currency: "BDT",
				value: data.items[0].price,
			});
			break;
		case "ADD_TO_CART": // DONE
			// GA
			makeGAEvent("add_to_cart", data);
			// Pixel
			makeFBQEvent("AddToCart", {
				content_ids: [data.items[0].id],
				content_name: data.items[0].name,
				content_type: "product",
				contents: [{ id: data.items[0].id, quantity: data.items[0].quantity }],
				currency: "BDT",
				value: data.items[0].price,
			});
			break;
		case "REMOVE_FROM_CART": // DONE
			// GA
			makeGAEvent("remove_from_cart", data);
			// Pixel: No relevant Pixel tag found
			break;
		case "BEGIN_CHECKOUT":
			// GA
			makeGAEvent("begin_checkout", data);
			// GA
			// makeGAEvent("Click", {
			// 	event_category: "Checkout",
			// 	event_label: "Place_Order",
			// });

			// Pixel
			makeFBQEvent("InitiateCheckout", {
				currency: "BDT",
				num_items: data.items.reduce((total, i) => total + i.quantity, 0),
				value: data.items.reduce((total, i) => total + i.price * i.quantity, 0),
			});
			break;
		case "SET_CHECKOUT_OPTION":
			// GA
			makeGAEvent("set_checkout_option", data);
			break;
		case "PURCHASE":
			// GA
			makeGAEvent("purchase", data);

			// Pixel
			makeFBQEvent("Purchase", {
				currency: "BDT",
				value: data.value,
			});
			break;
		default:
		// code block
	}
};

export const formatProductData = (data = {}, extraParams = {}) => {
	if (data) {
		if (typeof data === "object" && data.constructor && data.constructor.name == "Array") {
			// console.log("Array of Items");
			return data.map((i, k) => {
				return formatProductData(i, { ...{ list_position: k + 1 }, ...extraParams });
			});
		} else {
			// console.log("Item Object");
			const price = data.price * 1 || data.unit_price * 1 || 0;
			const sc = data.service_charge * 1 || 0;
			let item = {
				id: data.uid || data.product_uid || "",
				name: data.title || "",
				// category: data.category.slug || "",
				price: price + sc,
				list_position: 1,
			};

			if (data.category) {
				item.category = data.category;
			}

			if (data.quantity) {
				item.quantity = data.quantity;
			}

			return { ...item, ...extraParams };
		}
	} else {
		return null;
	}
};

export const doScrolling = (element, duration, extraY = 0) => {
	function getElementY(query) {
		return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top;
	}
	var startingY = window.pageYOffset;
	var elementY = getElementY(element) + extraY;
	// If element is close to page's bottom then window will scroll only to some position above the element.
	var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
	var diff = targetY - startingY;
	// Easing function: easeInOutCubic
	// From: https://gist.github.com/gre/1650294
	var easing = function (t) {
		return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	};
	var start;

	if (!diff) return;

	// Bootstrap our animation - it will get called right before next frame shall be rendered.
	window.requestAnimationFrame(function step(timestamp) {
		if (!start) start = timestamp;
		// Elapsed miliseconds since start of scrolling.
		var time = timestamp - start;
		// Get percent of completion in range [0, 1].
		var percent = Math.min(time / duration, 1);
		// Apply the easing.
		// It can cause bad-looking slow frames in browser performance tool, so be careful.
		percent = easing(percent);

		window.scrollTo(0, startingY + diff * percent);

		// Proceed with animation as long as we wanted it to.
		if (time < duration) {
			window.requestAnimationFrame(step);
		}
	});
};

export const handleChange = (e, setValues, plain = false) => {
	const key = e.target.name;
	const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

	if (plain) {
		setValues(value);
	} else {
		setValues((values) => ({
			...values,
			[key]: value,
		}));
	}
};

export const validateUrl = (url = "") => {
	const re = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
	return re.test(url);
};

export const formatBdtPrice = (val) => {
	// Custom function to format ##,##,###.##
	let input = val + "";
	let dec = "";
	let pos = input.indexOf(".");
	if (pos === -1) {
		// No decimals
	} else {
		// Decimals
		dec = input.substring(pos); // Get the decimal part
		dec = Math.round(parseFloat(dec) * 100) / 100; // Round to 2 decimal places
	}

	input = input.substring(0, pos !== -1 ? pos : input.length); // Remove the decimal part

	let num = input.slice(-3); // Get the last 3 digits
	input = input.slice(0, -3); // Omit the last 3 digits already stored in num

	while (input.length > 0) {
		// Loop to format digits 2 by 2
		num = input.slice(-2) + "," + num;
		input = input.slice(0, -2);
	}

	return num + dec;
};
